/**
 * @file authRequired.ts
 * @brief Read the 3D Secure details from a hold refused with AUTH_REQUIRED
 *        (402 body on /billing/preauthorize, 200 body on /s2s/start).
 *
 * @author DES
 * @date 18-10-2026
 */

/** Pull `{ clientSecret, paymentIntentId }` from an AUTH_REQUIRED body. */
export function authRequiredDetails(body: unknown): { clientSecret: string; paymentIntentId: string } | null {
  if (!body || typeof body !== "object") return null;
  const b = body as Record<string, unknown>;
  const code = b.code ?? b.error;
  if (code !== "AUTH_REQUIRED") return null;
  if (typeof b.clientSecret !== "string" || typeof b.paymentIntentId !== "string") return null;
  return { clientSecret: b.clientSecret, paymentIntentId: b.paymentIntentId };
}

